// extracted by mini-css-extract-plugin
export const title = "title-module--title--2f-3l";
export const about = "title-module--about--1Dq9r";
export const menus = "title-module--menus--2MU3c";
export const access = "title-module--access--1r41I";
export const prevention = "title-module--prevention--1QRPy";
export const payment = "title-module--payment--2MUsZ";
export const set = "title-module--set--3xmFh";